module.exports = "<div #content>\r\n  <ng-content></ng-content>\r\n</div>\r\n<div #intersection></div>\r\n"